import { LoadingOverlay } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { setJwtCache } from "services/jwtCache";
import { BASE_URLS } from "config";
import { getEnv } from "env";
import { getHybridToken } from "services/hybridAuthService";
import { OktaToken } from "services/oktaService";
import { SfdcToken } from "services/splatAuthService";
import { postMessage } from "messages";

const SplatLoginPage = () => {
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(true);
  const env = getEnv();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const oktaToken = searchParams.get("oktaToken") as OktaToken;
    const sfdcToken = searchParams.get("sfdcToken") as SfdcToken;
    if (oktaToken || sfdcToken) {
      getHybridToken(oktaToken ? "okta" : "salesforce", oktaToken || sfdcToken)
        .then(({ hybridToken }) => {
          setJwtCache({
            token: hybridToken,
            tokenType: oktaToken ? "okta" : "salesforce",
            source: "splat",
          });
          postMessage({
            type: "EVENT:AUTH_TOKEN",
            source: "Auth",
            payload: {
              tokenType: oktaToken ? "okta" : "salesforce",
              token: hybridToken,
            },
          });
          postMessage({
            type: "EVENT:LOGIN_SUCCESS",
            source: "Auth",
          });
          setLoading(false);
        })
        .catch(() => {
          setShowError(true);
          setLoading(false);
        });
    }
    // Intentionally empty dependency array to run only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoutOfSplat = useCallback(() => {
    postMessage({
      type: "COMMAND:CHANGE_URL",
      source: "Auth",
      payload: {
        url: `${BASE_URLS.SPLAT[env]}/logout`,
      },
    });
  }, [env]);

  return (
    <Page>
      {loading && <LoadingOverlay message="Sending you to ONE..." />}
      {showError && (
        <PageCenter>
          <div>
            There was an error logging you in. Please{" "}
            <InlineButton onClick={logoutOfSplat}>
              logout of Sales Platform
            </InlineButton>{" "}
            and try again.
          </div>
          <div>If this problem persists, please contact support.</div>
        </PageCenter>
      )}
    </Page>
  );
};

const Page = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #fffbf0;
`;

const PageCenter = styled.div`
  padding-top: 20vh;
  text-align: center;
`;

const InlineButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
  color: blue;
`;

export { SplatLoginPage };
